import React from 'react';
import { Box, Skeleton, Typography } from "@mui/material";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { format } from 'date-fns';
import EmptyIcon from "../../../assets/images/empty-box.png";

const getColor = (index) => {
    const colors = ["#8884d8", "#82ca9d", "#ffc658"];
    return colors[index % colors.length];
};

const AuthenticationCountComponent = (props) => {
    const { authenticationDateTypeCount, isFetchingAuthenticationCount, breakpoints } = props;

    console.log("isFetchingAuthenticationCount:", isFetchingAuthenticationCount);
    console.log("authenticationDateTypeCount:", authenticationDateTypeCount);

    const transformedData = transformData(authenticationDateTypeCount);

    const labels = ["Retail Level", "Box Level", "Pallet Level"]; 

    return (
        <Box width="100%" height={300} display="flex" alignItems="center" justifyContent="center">
            {isFetchingAuthenticationCount ? (
                <Skeleton 
                    variant="rectangular" 
                    width="100%" 
                    height={300} 
                    sx={{ 
                        backgroundColor: "rgb(108 139 222 / 30%)", 
                        display: 'block' 
                    }} 
                />
            ) : ( 
                <>
                    {(authenticationDateTypeCount && authenticationDateTypeCount.length !== 0) ? (
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={transformedData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="date" tickFormatter={date => format(new Date(date), 'MMM dd')} />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                {labels.map((label, index) => (
                                    <Bar key={label} dataKey={label} fill={getColor(index)} />
                                ))}
                            </BarChart>
                        </ResponsiveContainer>
                    ) : (
                        <Box sx={{ textAlign: "center", p: 1, pt: (breakpoints === "xs" || breakpoints === "sm") ? {} : "24px" }}>
                            <img alt="empty-data-icon" src={EmptyIcon} width="140" />
                            <Typography sx={{ color: "#58565f", fontSize: 14, mt: 1 }}>
                                No data available for the selected date range
                            </Typography>
                        </Box> 
                    )}
                </>
            )}
        </Box>
    );
};

const transformData = (data) => {
    const types = ["RL", "BL", "MPL"]; 

    return data.map(item => {
        console.log("data here", data)
        const transformedTypes = types.reduce((acc, type) => {
            const foundType = item.types.find(t => t.type === type);
            acc[type] = foundType ? foundType.count : 0;
            return acc;
        }, {});

        return {
            date: format(new Date(item.date), 'MMMM dd, yyyy'),
            ...transformedTypes,
            'Retail Level':transformedTypes.RL ,
            'Box Level':transformedTypes.BL ,
            'Pallet Level':transformedTypes.MPL 
        };
    });
};

export default AuthenticationCountComponent;
